const quickLinks = [
  { label: "本周瓜", href: "#weekly" },
  { label: "本月盘点", href: "#monthly" },
  { label: "事件合集", href: "#collection" },
  { label: "热门人物", href: "#people" },
];

const guideLinks = [
  { label: "吃瓜指南", href: "#about" },
  { label: "常见问题", href: "#faq" },
  { label: "订阅瓜报", href: "#subscribe" },
];

export default function Footer() {
  return (
    <footer className="border-t-4 border-primary-500 bg-background-100">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2" aria-label="最新吃瓜">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-white">
                <i className="ri-fire-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-900">最新吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              近期热门事件一网打尽。把分散各处的本周瓜、本月盘点和新近合集集中整理，陪你高效补课、理性吃瓜。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#subscribe"
                aria-label="订阅瓜报"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
              >
                <i className="ri-mail-fill" aria-hidden="true" />
              </a>
              <a
                href="#top"
                aria-label="回到顶部"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-accent-500 hover:text-white"
              >
                <i className="ri-arrow-up-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-black text-foreground-900">内容栏目</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-black text-foreground-900">站点导航</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {guideLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-black text-foreground-900">联系合作</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li>
                <a href="mailto:hello@zuixinchigua.example" className="transition-colors hover:text-primary-600">
                  hello@zuixinchigua.example
                </a>
              </li>
              <li>非商业转载请注明来源</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 最新吃瓜 · 近期热门事件一网打尽，所有信息均整理自公开报道。
          </p>
          <p className="text-xs text-foreground-500">理性吃瓜 · 文明发言 · 尊重每个人</p>
        </div>
      </div>
    </footer>
  );
}